import { render, staticRenderFns } from "./ContactIcon.vue?vue&type=template&id=113506e1&scoped=true&"
import script from "./ContactIcon.vue?vue&type=script&lang=ts&"
export * from "./ContactIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ContactIcon.vue?vue&type=style&index=0&id=113506e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113506e1",
  null
  
)

export default component.exports